import React from 'react';
import iconify from '../iconify';

const Lock = ({customColor, ...props}) => (
  <svg width="1em" height="1em" viewBox="0 0 12.1 15.7" {...props}>
    <path
      fill={customColor ? customColor : 'currentColor'}
      d="M10.7 7.1V4.7C10.7 2.1 8.6 0 6 0S1.3 2.1 1.3 4.7v2.4C.6 7.3 0 7.9 0 8.7v5.4c0 .9.7 1.7 1.7 1.7h8.7c.9 0 1.7-.7 1.7-1.7V8.7c-.1-.7-.6-1.4-1.4-1.6zm-4 5.2v1.6H5.3v-1.6c-.5-.3-.8-.7-.8-1.3 0-.8.7-1.5 1.5-1.5.5 0 1 .3 1.3.7.4.8.1 1.7-.6 2.1zm1.5-5.2H3.8V4.7c0-1.2 1-2.2 2.2-2.2 1.2 0 2.2 1 2.2 2.2v2.4z"
    />
  </svg>
);

export default iconify(Lock);
